import { useEffect, useState, useCallback } from "react";
import { Badge } from "@mui/material";
import PropTypes from "prop-types";
import { useUserData } from "src/context/userContext";

export default function ConnectedIcon(props) {
  const { socket } = useUserData();
  const showUsercount = props.showUsercount || true;
  const [socketConnected, setSocketConnected] = useState(false);
  const [connCount, setConnCount] = useState(0);
  const variant = props.variant || "dot";

  const connectListener = useCallback((connCount) => {
    setConnCount(connCount);
  });

  useEffect(() => {
    if (!socket) {
      setSocketConnected(false);
      setConnCount(0);
      return;
    }
    setSocketConnected(true);
    if (showUsercount && socket) {
      socket.on("connCount", connectListener);
      socket.emit("connCount");
    }

    return () => {
      socket && socket.off("connCount", connectListener);
    };
  }, [socket]);
  if (variant === "number") return connCount;
  //if (variant === "dot" || true)
  return (
    <div className="noPrint">
      <Badge
        badgeContent={connCount}
        color={socketConnected ? "success" : "error"}
        showZero
        sx={{
          "& .MuiBadge-badge": {
            fontSize: 9,
            height: 15,
            minWidth: 15,
          },
        }}>
        {props.children}&nbsp;&nbsp;
      </Badge>
    </div>
  );
}

ConnectedIcon.propTypes = {
  socket: PropTypes.object,
  showUsercount: PropTypes.bool,
  children: PropTypes.node,
  variant: PropTypes.string,
};
